import { FC, memo, useEffect, useState, useContext } from 'react'
// import styles from './index.module.less';
import { Menu } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import globalContext from '~/contexts/global.context'
import { IMenus, ISubMenu } from '~/data-model/common'
import { getMenuSelectedAndOpenKey } from '~/utils/menu'

const { SubMenu } = Menu

function isISubMenu(data: ISubMenu | IMenus): data is ISubMenu {
  return (data as ISubMenu).children !== undefined
}

const Component: FC = () => {
  const [openKeys, setopenKeys] = useState<string[]>([])
  const [selectedKeys, setselectedKeys] = useState<string[]>([])

  const location = useLocation()
  const context = useContext(globalContext)

  useEffect(() => {
    const result = getMenuSelectedAndOpenKey(context.menus, location.pathname)
    // console.log(result, 'result')
    result.openKeys.length && setopenKeys(result.openKeys)
    result.selectedKeys.length && setselectedKeys(result.selectedKeys)
  }, [context.menus, location])

  const renderMenu = (data: (ISubMenu | IMenus)[], key = '') => {
    return data.map((item) => {
      const pk = key + item.title

      const Icon = item.icon
      return isISubMenu(item) ? (
        <SubMenu key={pk} title={item.title} icon={Icon && <Icon style={{ fontSize: 20 }} />}>
          {renderMenu(item.children || [], pk)}
        </SubMenu>
      ) : (
        <Menu.Item key={item.path} title={item.title} icon={Icon && <Icon style={{ fontSize: 20 }} />}>
          <Link to={item.path}>{item.title}</Link>
        </Menu.Item>
      )
    })
  }

  return (
    <Menu theme="dark" selectedKeys={selectedKeys} openKeys={openKeys} mode="inline" onOpenChange={(keys) => setopenKeys(keys as any)}>
      {renderMenu(context.menus)}
    </Menu>
  )
}

Component.displayName = 'SideMenus'

const SideMenus = memo(Component)
export default SideMenus
